<template>
  <div>
    <Checkbox
      class="cb-card mt-10 heading-4 weight-medium"
      title='Self-Employment'
      v-model="income.isSZCO"
      :checked="income.isSZCO"
    >
      <ul class="body-3 weight-regular pt-5">
        
    <li>Trade Licence</li>
    <li>Agricultural Production</li>
    <li>Freelance Work</li>
    <li>Source of Profit (v. o. s., k. s., s. r. o.)</li>
    <li>Physical Person in Temporary or Supported Employment</li>
  
      </ul>

      <div v-if="income.isSZCO">
        <div class="input-box-holder mt-5" v-validate="errors" v-has-value="income.companyName">
          <TextField
            class="input-box"
            v-model.trim="income.companyName"
            title='Name of Business or Trade'
            :id="`name_${index}`"
            required
          />
          <div class="validation-output text-left mt-2">
            <ErrorHandler class="error" :id="`V048_${index}`">
              Enter the company name. 
            </ErrorHandler>
          </div>
        </div>
      </div>
    </Checkbox>
  </div>
</template>
<script>
import TextField from '@/components/TextField/TextField.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  name: 'CompanyPackage',
  components: { Checkbox, TextField, ErrorHandler },
  props: {
    income: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
  },
};
</script>
